import { render, staticRenderFns } from "./CreateInputPph.vue?vue&type=template&id=5c0404ec&"
import script from "./CreateInputPph.vue?vue&type=script&lang=ts&"
export * from "./CreateInputPph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0404ec')) {
      api.createRecord('5c0404ec', component.options)
    } else {
      api.reload('5c0404ec', component.options)
    }
    module.hot.accept("./CreateInputPph.vue?vue&type=template&id=5c0404ec&", function () {
      api.rerender('5c0404ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-receivables/CreateInputPph.vue"
export default component.exports